
import Vue from "vue";
import ScrollablePane from "@/shared/components/ScrollablePane.vue";

export default Vue.extend({
    name: "TitledSection",
    components: {
        ScrollablePane,
    },
    props: {
        title: {
            type: String,
            required: false,
            default: "",
        },
        scrollable: {
            type: Boolean,
            required: false,
            default: false,
        },
        maxHeight: {
            type: String,
            required: false,
        },
    },
});
